// extracted by mini-css-extract-plugin
export var colorSquare = "_qb-0";
export var danger = "_qb-5";
export var lightPink = "_qb-8";
export var neutralBlue = "_qb-7";
export var neutralYellow = "_qb-6";
export var normal = "_qb-1";
export var primary = "_qb-2";
export var primaryLight = "_qb-3";
export var solidBlack = "_qb-g";
export var solidGreen = "_qb-b";
export var solidLightBlue = "_qb-d";
export var solidNavy = "_qb-c";
export var solidOrange = "_qb-f";
export var solidPink = "_qb-e";
export var solidRed = "_qb-9";
export var solidYellow = "_qb-a";
export var success = "_qb-4";